<template>
    <div class="hello-page-wrapper video-player-wrapper rating-wrapper">
        <div class="watch-again">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p class="congratz">Congrats! You learned a new lorem ipsum dolor sit amet today</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="current-video-img">
                            <img :src="currentVideo.img" :alt="currentVideo.title">
                            <a class="btn btn-link">
                                <i class="glyphicon glyphicon-play" ></i> &nbsp;&nbsp; watch again
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="rating">
                            <ul class="chart-skills">
                                <li>
                                    <span>Rating 1</span>
                                </li>
                                <li>
                                    <span>Rating 2</span>
                                </li>
                                <li>
                                    <span>Rating 3</span>
                                </li>
                                <li>
                                    <span>Rating 4</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <h3>Use these 7 Tips to Climb the Corporate Ladder</h3>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                            been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                            galley of type and scrambled it to make a type specimen book. It has survived not only five
                            centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
                            It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
                            passages, and more recently with desktop publishing software like Aldus PageMaker including
                            versions of Lorem Ipsum
                        </p>
                        <p class="recently-watched">
                            <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View Transcript</button>
                        </p>
                        <div class="author">
                            <div class="authorContent">
                                <img src="../assets/live-event-two.png" alt="">
                                <h4>Joelle K. Jay</h4>
                                <h5>Author, CEO</h5>
                            </div>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                                been the industry's standard dummy text ever
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="recently-watched">
            <div class="container">
                <div class="row" v-if="getAuthRecommendedVideos">
                    <div class="col-md-12">
                        <h2>RELATED VIDEOS</h2>
                    </div>
                    <div class="col-md-12">
                        <div class="content">
                            <div class="slider responsive-slick-slider">
                                <div v-for = "reccentVideo in recommendationList">
                                    <div class="slide-player">
                                        <img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid)" />
                                        <p>
                                            {{reccentVideo.title}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View All Your Videos</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'

    export default {
        name: 'player',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList
        },
        methods: {
            redirectToRelatedVideos () {
                this.$router.push(`/relatedvideos`)
            },
            onVideoComplete () {
                this.currentStatus.watched = 'F'
                this.currentStatus.durationWatched = '100'
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setUserLike () {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt((watchedDuration / this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set User Like/Dislike
                if (this.currentStatus.liked === '1') {
                    this.currentStatus.liked = '0'
                } else {
                    this.currentStatus.liked = '1'
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setRating (desc) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set Rating
                let rating = '0'
                if (desc === 'funny') {
                    rating = '1'
                } else if (desc === 'smart') {
                    rating = '2'
                } else if (desc === 'helpful') {
                    rating = '3'
                } else {
                    rating = '0'
                }
                this.currentStatus.rating = rating
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            logVideoEntry () {
                let logWatchedEntry = {
                    videoCode: this.$route.params.videoCode,
                    userId: this.user.userId,
                    playlistId: null,
                    playlistCode: null,
                    watched: 'N',
                    rating: null,
                    liked: '0',
                    durationWatched: 0,
                    thumbnailURL: null
                }
                this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                    console.log('added')
                })
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/watch/${videoCode}`)
                location.reload()
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            }
        },
        data: function () {
            return {
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: this.$route.params.videoCode,
                recommendationList: ''
            }
        },
        mounted: function () {
            // Retreive Video Object
            this.$store.dispatch('GETCURRENTVIDEO', this.$route.params.videoCode).then(() => {
                let video = this.getCurrentVideo
                this.currentVideo = {
                    video: video[0].sources[3].file,
                    title: video[0].title,
                    img: video[0].image,
                    playerID: new Date()
                }
                this.$store.dispatch('GETEXPERT', video[0].expertid).then(() => {
                })
                this.logVideoEntry()
            })
            // Get Video Transcript
            this.$store.dispatch('GETVIDEOTRANSCRIPT', this.$route.params.videoCode).then(() => {
            })
            // Get Recommended Videos
            this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(() => {
                let code
                console.log(code)
                let filteredList = this.getAuthRecommendedVideos.filter(code => {
                    return code.mediaid !== this.currentVideoCode
                })
                this.recommendationList = filteredList
                setTimeout(() => {
                    this.setCarousal()
                }, 2000)
                // this.recommendedVideos = this.getAuthRecommendedVideos
            })
            // Get User Videos Reference
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                if (this.getAuthUserVideos) {
                    let code = this.$route.params.videoCode
                    let exists = this.getAuthUserVideos.filter(code => {
                        return code.videoCode === this.currentVideoCode
                    })
                    if (exists && exists.length > 0) {
                        this.currentStatus = exists[0]
                    } else {
                        this.currentStatus = {
                            videoCode: this.$route.params.videoCode,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '0',
                            durationWatched: 0,
                            thumbnailURL: null
                        }
                    }
                    console.log(code)
                }
            })
            function init () {
                setHeight()
                initilizer()
            }
            function initilizer () {
                $('.rate').mouseover(function () {
                    changeHeight()
                })
                $('.share').mouseover(function () {
                    showSharing()
                })
                $('.video-player').on('mouseleave', '.right-hover-width', function () {
                    resetHeight()
                })
            }
            function showSharing () {
                $('.share-hover-box').show()
                $('.left-video-icons').hide()
                $('.right-video-icons').addClass('right-hover-width')
                $('.icons-hover').addClass('icon-hover-width')
            }
            function resetHeight () {
                $('.left-video-icons').show()
                $('.right-video-icons').removeClass('right-hover-width')
                $('.icons-hover').removeClass('icon-hover-width')
                $('.rate-hover-box').hide()
                $('.share-hover-box').hide()
            }
            function changeHeight () {
                $('.left-video-icons').hide()
                $('.right-video-icons').addClass('right-hover-width')
                $('.icons-hover').addClass('icon-hover-width')
                $('.rate-hover-box').show()
            }
            function setHeight () {
                var $tabPane = $('.tab-pane')
                var tabsHeight = $('.nav-tabs').height()
                $tabPane.css({
                    height: tabsHeight
                })
            }
            $(init)
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Rating.vue?23fd3df9